// extracted by mini-css-extract-plugin
export default {"logsContainer":"styles_logsContainer__ZlC4Q","responseContainer":"styles_responseContainer__dpn1q","response":"styles_response__Ztycf"};